import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect, useDispatch } from 'react-redux'
import arraySort from 'array-sort'
import withApiData from '../components/HOC/withApiData'
import Header from '../components/mycourses/Header'
import useFetchData from '../components/mycourses/hooks/useFetchData'
import styled from 'styled-components'
import _ArrowIcon from '../static/images/mycourses/Arrow.svg'
import Courses from '../components/mycourses/Courses/Courses'
import { setSelectedAcademicYearGlobally } from '../actions/mycourses'
import ResponsiveContainer from '../components/mini/Layout/ResponsiveContainer'
import useFetchOrgFlags from '../components/mycourses/hooks/useFetchOrgFlags'

const NoCoursesBlock = styled.div`
  position: relative;
  height: 63vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const NoCoursesMessage = styled.p`
  color: #808080;
  font-family: Roboto;
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 29px;
  text-align: center;
  padding-top: 25px;
`

const ArrowIcon = styled.img.attrs({
  src: _ArrowIcon
})`
  align-self: flex-end;
  margin-right: 180px;
  width: 103px;
  height: 136px;
`

const MyCourses = ({
  user,
  frameworkSubjects,
  gradeLevels,
  organization,
  selectedAcademicYearGlobally
}) => {
  const dispatch = useDispatch()
  const [selectedAcademicYear, setSelectedAcademicYear] = useState(
    selectedAcademicYearGlobally !== null ? selectedAcademicYearGlobally : {}
  )
  const { isDataLoading, academicYears, mentorMasterCourses } = useFetchData(
    organization.orgId,
    user.token,
    selectedAcademicYear.id
  )

  const { isLoadingOrgFlags, orgFlags } = useFetchOrgFlags(organization.orgId, user.token)

  useEffect(() => {
    if (academicYears !== undefined) {
      const sortedAcademicYear = arraySort(academicYears, 'sort_order')
      dispatch(setSelectedAcademicYearGlobally(sortedAcademicYear[0]))
      setSelectedAcademicYear(sortedAcademicYear[0])
    }
  }, [academicYears])

  const handleSelectedAcademicYearChange = e => {
    if (e.id !== selectedAcademicYear.id) {
      dispatch(setSelectedAcademicYearGlobally(e))
      setSelectedAcademicYear(e)
    }
  }

  return isDataLoading ? (
    <div className="loading" />
  ) : (
    <ResponsiveContainer>
      <Header
        dispatch={dispatch}
        user={user}
        academicYears={academicYears}
        selectedAcademicYear={
          academicYears !== undefined && selectedAcademicYear
        }
        handleSelectedAcademicYearChange={handleSelectedAcademicYearChange}
        frameworkSubjects={frameworkSubjects}
        gradeLevels={gradeLevels}
        organization={organization}
        orgFlags={orgFlags}
      />
      {mentorMasterCourses !== undefined && mentorMasterCourses.length ? (
        <Courses
          mentorMasterCourses={mentorMasterCourses}
          academicYears={academicYears}
          selectedAcademicYearId={selectedAcademicYear.id}
          gradeLevels={gradeLevels}
          orgFlags={orgFlags}
        />
      ) : (
        <NoCoursesBlock>
          <ArrowIcon />
          <NoCoursesMessage>
            You haven’t created any courses for this academic year. <br />
            Tap here to create a new course!
          </NoCoursesMessage>
        </NoCoursesBlock>
      )}
    </ResponsiveContainer>
  )
}

MyCourses.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  frameworkSubjects: PropTypes.array.isRequired,
  gradeLevels: PropTypes.array.isRequired,
  organization: PropTypes.object.isRequired
}

export const mapStateToProps = state => ({
  user: state.user.user,
  frameworkSubjects: state.frameworksubjects.items,
  gradeLevels: state.gradelevels.items,
  organization: state.organization,
  selectedAcademicYearGlobally: state.mycourses.selectedAcademicYearGlobally
})

export default connect(mapStateToProps)(withApiData(MyCourses))



// WEBPACK FOOTER //
// ./src/containers/MyCourses.js